export default __webpack_public_path__ + "static/media/white-logo.fdd9aff6.png";